import { render } from "./SliderVue.vue?vue&type=template&id=950e5fe6&scoped=true"
import script from "./SliderVue.vue?vue&type=script&lang=js"
export * from "./SliderVue.vue?vue&type=script&lang=js"

import "./SliderVue.vue?vue&type=style&index=0&id=950e5fe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950e5fe6"]])

export default __exports__